import api from '../lib/api'

// Nhật ký bot API (backend `app/routers/reply_log.py`). Every call is scoped to one tenant.
const base = (tenantId) => `/admin/tenants/${tenantId}/reply-log`

// params: { review: 'all'|'unrated'|'right'|'wrong', gate: 'all'|'no_match', jev: 'all'|'disagree', limit, before }.
export const listReplyLog = (tenantId, params = {}) =>
  api.get(base(tenantId), { params }).then((r) => r.data)

export const getReplyLogEntry = (tenantId, replyId) =>
  api.get(`${base(tenantId)}/${replyId}`).then((r) => r.data)

// body: { verdict: 'right'|'wrong', comment?, question?, sentiment_override? }.
export const rateReplyLogEntry = (tenantId, replyId, body) =>
  api.put(`${base(tenantId)}/${replyId}/rating`, body).then((r) => r.data)
